import { Container, Box, Button } from '@mui/material'
import type React from 'react'
import Header from 'Components/Header'
import { Footer } from 'Components/Footer'
import { useAccountId } from 'ContextProviders/CurrentAccount'
import AlertMessage from 'Components/AlertMessage'
import { useEffect } from 'react'
import { useAuth } from 'hooks/use-auth'
import { Role } from 'core/types'
import { useLocation } from 'react-router'
import { useAppSelector } from 'hooks/reduxHooks'
import { clear, duplicateStateSelector } from 'slices/duplicateChildSlice'
import { useDispatch } from 'react-redux'
import * as AppRoutes from 'Pages/Routes'

export const Layout = (props: {
  children: React.ReactNode
}): JSX.Element => {
  const auth = useAuth()
  const acct = useAccountId()
  const v4Url = process.env.REACT_APP_V4URL ?? ''
  let isOnlyV4 = false
  const isIsdUser = auth.user?.securityLevel === Role.ISD_USER
  const isSpUser = auth.user?.securityLevel === Role.SERVICE_PROVIDER_USER
  const isIntakeUser = auth.user?.securityLevel === Role.INTAKE_USER
  if (isIsdUser && !((auth.user?.isDs.some(i => !(i.v4Enabled ?? false))) ?? false)) {
    isOnlyV4 = true
  } else if ((isSpUser || isIntakeUser) && !((auth.user?.serviceProviders.some(s => !(s.v4Enabled ?? false)) ?? false))) {
    isOnlyV4 = true
  }
  useEffect(() => {
    if (v4Url !== '' && acct?.v4Enabled === true && isOnlyV4 && !auth.isImpersonating()) {
      setTimeout(() => {
        clickLink()
      }, (20000))
    }
  }, [isOnlyV4, acct])
  const clickLink = (): void => {
    window.location.href = v4Url
  }
  const location = useLocation()
  const dupeState = useAppSelector(duplicateStateSelector)
  const dispatch = useDispatch()
  const headlessRoutes = [AppRoutes.LOGIN, AppRoutes.FORGOT_PASSWORD, AppRoutes.RESET_PASSWORD]
  if (auth.user == null) { headlessRoutes.push(AppRoutes.LANDING_PATH) }
  const escapedRoutes = headlessRoutes.map(r => r.replace(/\/$/, ''))
  const hideHeader = escapedRoutes.includes(location.pathname.replace(/\/$/, ''))

  useEffect(() => {
    const dupePaths = [AppRoutes.DUPLICATE_LIST, AppRoutes.DUPE_MANAGEMENT, AppRoutes.DUPE_REVIEW, AppRoutes.CARENETWORK_MANAGEMENT_EDIT, AppRoutes.DUPE_ACTION]
    if (dupeState?.duplicateChild != null && !dupePaths.some(l => l.replace('/:id?', '') === location.pathname.replace(/\/\d+$/, ''))) {
      dispatch(clear())
    }
  }, [location])
  const warningText = 'You need to use version 4 of MiECC. ' +
      'Please update your bookmarks. ' +
      (isOnlyV4 && !auth.isImpersonating() ? 'You will be redirected to version 4 automatically in 20 seconds, otherwise click' : 'Click')
  const warningText2 = ' to go now.'
  return (
    <Box sx={{ height: '100vh', width: '100%' }}>
      {(acct?.v4Enabled ?? false) && v4Url !== '' && <AlertMessage message={warningText}
        link={<Button variant='text' onClick={clickLink}>here</Button>} secondMessage={warningText2} type={'warning'}
      />}
      {!hideHeader && <Header />}
      <Container
        key='displayContainer'
        maxWidth={false}
        sx={{
          '&&': {
            pl: hideHeader ? '0px' : { sm: '0px', md: '300px' }
          },
          px: 0,
          flexGrow: 1,
          width: '100%',
          pb: '40px',
          flexWrap: '',
          justifyContent: 'start'
        }}
      >
        <Box width={'100%'}>
          {props.children}
        </Box>
      </Container>

      <Footer />
    </Box>
  )
}
